<div class="close-btn-outer">
    <button mat-mini-fab color="warn" (click)="close()"><i class="material-icons" data-icon="close"></i></button>
</div>
<div mat-dialog-content>
    <div fxLayout="row wrap">
        <div fxFlex="100" fxFlex.gt-sm="50"> 
            <div class="swiper-container h-100" [swiper]="config">
                <div class="swiper-wrapper">
                    <div *ngFor="let image of product.images" class="swiper-slide">
                        <img src="data:," [imgName]="image.medium" imgType="products" imgSize="md" 
                            class="swiper-lazy" ngClass.lt-md="sm" imagePreload alt = "{{product['product']['description']}}" />
                        <div class="swiper-lazy-preloader"></div>
                    </div>
                </div>
                <button mat-icon-button class="swiper-button-prev swipe-arrow"><mat-icon>keyboard_arrow_left</mat-icon></button>
                <button mat-icon-button class="swiper-button-next swipe-arrow"><mat-icon>keyboard_arrow_right</mat-icon></button>
            </div>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="50" ngClass.gt-sm="px-2 m-0" ngClass.sm="mt-2" ngClass.xs="mt-2"> 
            <h2>{{product['product']['description']}}</h2>
            <div class="py-1 lh">
                <p>
                    <span class="text-muted fw-500">Category: </span>
                    <span>{{ product['product']['cb_category']['category_name'] }}</span>
                </p>
            </div>
            <!-- <p class="py-1 text-muted lh description"  
                [innerHTML]="product['product']['website_description'] | sanitizeHtml"></p> -->
                <p class="py-1 text-muted lh description">
                    <span>{{  productDescription | limitWords }}</span>
                </p>
            <!-- <div fxLayoutAlign="end center" class="text-muted" *ngIf="storeDetailsJson['settings']">                 
                <button *ngIf="storeDetailsJson['settings']['productFullView'] === true" 
                    [mat-dialog-close]="product" mat-icon-button matTooltip="View full details">
                    <mat-icon>arrow_forward</mat-icon>
                </button>               
           </div> -->
            <div class="divider" fxShow="false" fxShow.gt-sm="true"></div>
            <div fxLayout="row" fxLayoutAlign="space-between center" fxShow="false" fxShow.gt-sm="true">
                <h2 class="mt-1 new-price">{{storeCurrency}}{{product['product']['retail_price'] | number: '1.2-2'}}</h2>
                <app-controls *ngIf="product" [type]="'dialog'" [product]="product" 
                    [store]="product['storeDetails']"></app-controls>
            </div>

        </div>
    </div>
</div>
<div mat-dialog-actions fxShow="false" fxShow.lt-md="true">
    <div fxFlex="100%" fxLayout="row" fxLayoutAlign="space-between center">
        <h2 class="new-price">{{storeCurrency}}{{product['product']['retail_price'] | number: '1.2-2'}}</h2>
        <app-controls *ngIf="product" [type]="'dialog'" [product]="product" 
            [store]="product['storeDetails']"></app-controls>
    </div>
</div>